import { ContentPaste } from '@mui/icons-material';
import { IconButton, SxProps, Theme } from '@mui/material';

interface PasteFromClipboardButtonProps {
	size?: 'small' | 'medium' | 'large';
	title?: string;
	edge?: 'start' | 'end' | false;
	iconSize?: number;
	sx?: SxProps<Theme>;
	onClick: () => void;
	disabled?: boolean;
}

export default function PasteFromClipboardButton({
	size = 'small',
	title = 'Paste value from clipboard',
	edge = 'end',
	iconSize = 18,
	sx,
	onClick,
	disabled = false,
}: PasteFromClipboardButtonProps) {
	return (
		<IconButton size={size} onClick={onClick} title={title} edge={edge} sx={sx} disabled={disabled}>
			<ContentPaste sx={{ fontSize: iconSize }} />
		</IconButton>
	);
}
